<nav class="header" aria-label="main navigation">
  <div class="header-container">
    <span class="header-branding">
      <img class="header-logo" [src]="logoImageUrl()" [ngClass]="logoClass()" />
    </span>

    <div class="header-content" [ngSwitch]="getComponentRenderState()">
      <ng-container *ngSwitchCase="'loading'">
        <div class="auth-points-loading"></div>
      </ng-container>

      <ng-container *ngSwitchCase="'loggedOut'">
        <button (click)="login()">
          <span class="login-text">{{ 'header.log_in' | translate }}</span>
        </button>
      </ng-container>

      <ng-container *ngSwitchCase="'loggedIn'">
        <a class="user-balance" [routerLink]="['/points_activity']">
          <span class="points-balance">{{ pointsBalance }}</span>
          <span class="points-currency ml-1">{{ currencyShortName() }}</span>
        </a>
      </ng-container>
    </div>
  </div>
</nav>
